export default __webpack_public_path__ + "universal/images/default.6779a2a61da174726b74c5376a843a7f.png";